import { GENERATE_PDF } from "./invoice-view.query";
import { IInvoiceViewResponse } from "./invoice-view.interface";
import { useMutation } from "@apollo/client";

export const useInvoicePDF =() =>{
  const [generatePdf, { data, loading }] = useMutation<{generatePdf: IInvoiceViewResponse}>(GENERATE_PDF);


  const getInvoicePDF = (id: string) => {
    generatePdf({
      variables: { id },
    });
  };


  return {
    downloadloading: loading,
    getInvoicePDF,
    invoicePDFDetails: data?.generatePdf,
  };
};

export default useInvoicePDF;
